const tool = {};
/** 金额方法 **/
tool.toThousands = function (num) {
  if ((num + '').indexOf('.') == -1) {
    num = num + '.00'
  }
  if (Number.isInteger(num)) {
    num = (num || 0).toFixed(2).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    return num ;
  } else {
    return num = ( num ? (Math.round(num * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : 0)
  }
}
/**
 * 合计
 */
tool.totalTable = function (fromTable, toTable) {
    fromTable.forEach(element => {
        toTable.goodslstQty += element.goodslstQty !== undefined ? element.goodslstQty : null
        toTable.goodslstWeight += element.goodslstWeight !== undefined ? element.goodslstWeight : null
        toTable.goodslstVolume += element.goodslstVolume !== undefined ? element.goodslstVolume : null
    })
    if (fromTable.length !== 0) {
        fromTable.push(toTable)
    }
}
import Vue from "vue"
tool.keyValue = function (form) {
  let obj = {}
  for (var key in form) {
    if (form[key]) {
      Vue.set(obj, key, form[key])
    }
  }
  const qs = require('qs')
  let str = qs.stringify(obj)
  return str
}
/**
 * 补差
 */
tool.balancePayTable = function (fromTable, toTable, pushTable) {
    pushTable.goodslstWeight = fromTable.wAddition ? fromTable.wAddition : 0
    pushTable.goodslstVolume = fromTable.vAddition ? fromTable.vAddition : 0
    toTable.push(pushTable)
}

tool.formatDate = function (date, format = '-') {
  if (!date) return ''
  date = typeof date === 'string'
      ? new Date(date)
      : date
  let currentMonth, currentDay
  let month = (currentMonth = date.getMonth() + 1) > 9
      ? currentMonth
      : ('0' + currentMonth)
  let day = (currentDay = date.getDate()) > 9
      ? currentDay
      : ('0' + currentDay)
  return date.getFullYear() + format + month + format + day
}

  /**
 * 使用blob及a标签导出流文件
 */
// console.log(process.env.NODE_ENV)
tool.downloadExecl = function (url, message) {
    let blob = new Blob([url], {
      type: 'application/octet-stream'
    })
    let a = document.createElement('a')
    let href = window.URL.createObjectURL(blob) // 创建下载的链接
    a.href = href
    // a.target = '_blank'
    a.download = message // 下载后文件名
    document.body.appendChild(a)
    a.click() // 点击下载
    document.body.removeChild(a) // 下载完成移除元素
    window.URL.revokeObjectURL(href)
  }
export default tool;

//发布状态
tool.release = function (type){
  let text
  switch (type) {
    case 0:
      text = '草稿'
      break;
    case 1:
      text = '更新'
      break;
    case 2:
      text = '已发布'
      break;
    default:
      break;
  }
  return type = text
}

tool.releaseColor = function (type){
  let color
  switch (type) {
    case 0:
      color = 'red'
      break;
    case 1:
      color = '#f27302'
      break;
    case 2:
      color = 'green'
      break;
    default:
      break;
  }
  return type = color
}

tool.transform = function (type){
  let text
  switch (type) {
    case 0:
      text = '其他'
      break;
    case 1:
      text = 'int'
      break;
    case 2:
      text = 'long'
      break;
    case 3:
      text = 'double'
      break;
    case 4:
      text = 'decimal'
      break;
    case 5:
      text = 'string'
      break;
    case 6:
      text = 'date'
      break;
    case 7:
      text = 'boolean'
      break;
    default:
      break;
  }
  return type = text
}

//日志级别
tool.level = function (type){
  let text
  switch (type) {
    case 1:
      text = '数据'
      break;
    case 2:
      text = '信息'
      break;
    case 3:
      text = '错误'
      break;
    default:
      break;
  }
  return type = text
}

//日志数据类型
tool.dataType = function (type){
  let text
  switch (type) {
    case 1:
      text = 'JSON'
      break;
    case 2:
      text = 'SQL语句'
      break;
    case 3:
      text = 'XML'
      break;
    default:
      break;
  }
  return type = text
}


// WEBPACK FOOTER //
// ./src/tool/index.js